import script from "./RelatedActionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedActionsList.vue?vue&type=script&setup=true&lang=js"

import "./RelatedActionsList.vue?vue&type=style&index=0&id=5938abea&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5938abea"]])

export default __exports__